import React from 'react';

export default function ParticipationHighlightControl({checked,onChange}) {
  return <label className="calendar-participation-key calendar-participation-toggle"><input type="checkbox" checked={checked} onChange={event=>onChange(event.target.checked)}/>Highlight events you’re participating in</label>;
}
